/*
  Native "Do you want to stitch?" options — replaces the Aris / APO app on the PDP.

  Default path is untouched: when nothing is ticked, the theme's own ProductForm
  submit runs exactly as before. Only when at least one service is ticked does this
  take over, so it can send the saree and its add-on lines in ONE /cart/add.js call
  (two calls would leave a saree without its stitching if the second one failed).

  The cart contract mirrors the app byte for byte — see snippets/mtl-stitch-options.liquid.
*/
(function () {
  'use strict';
  if (window.__mtlStitch) return;
  window.__mtlStitch = true;

  var PARENT_PROP = 'Do you want to stitch';

  function fieldsetFor(form) {
    var scope = form.closest('product-info') || form.closest('.product') || document;
    return scope.querySelector('[data-mtl-stitch]');
  }

  function chosen(fs) {
    if (!fs) return [];
    return Array.prototype.slice
      .call(fs.querySelectorAll('.mtl-stitch__cb'))
      .filter(function (cb) { return cb.checked && !cb.disabled; })
      .map(function (cb) {
        return {
          id: cb.dataset.variantId,
          label: cb.value,
          price: parseInt(cb.dataset.price, 10) || 0
        };
      });
  }

  function money(paise) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0
      }).format(paise / 100);
    } catch (e) {
      return 'Rs.' + Math.round(paise / 100);
    }
  }

  // Keeps the hidden property field and the running total in step with the ticks.
  function sync(fs) {
    if (!fs) return;
    var picked = chosen(fs);
    var prop = fs.querySelector('[data-mtl-stitch-prop]');
    var total = fs.querySelector('[data-mtl-stitch-total]');

    if (prop) {
      if (picked.length) {
        prop.value = picked.map(function (p) { return p.label; }).join(', ');
        prop.disabled = false;
      } else {
        prop.value = '';
        prop.disabled = true;
      }
    }
    if (total) {
      if (picked.length) {
        var sum = picked.reduce(function (a, p) { return a + p.price; }, 0);
        total.textContent = 'Stitching added: ' + money(sum);
        total.hidden = false;
      } else {
        total.hidden = true;
      }
    }
    var err = fs.querySelector('[data-mtl-stitch-error]');
    if (err) err.hidden = true;
  }

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('mtl-stitch__cb')) return;
    sync(e.target.closest('[data-mtl-stitch]'));
  });

  // Dawn renders the quantity input and some blocks OUTSIDE <form>, associated
  // by the form="" attribute — form.querySelector() misses those, form.elements
  // does not. FormData works for the theme for the same reason.
  function controls(form) {
    return Array.prototype.slice.call(form.elements || []);
  }

  function fieldValue(form, name) {
    var el = form.elements ? form.elements[name] : null;
    if (!el) return null;
    if (el.value === undefined && el.length) el = el[0];
    return el && el.value !== undefined ? el.value : null;
  }

  // Every line item property already on the form (e.g. the delivery app's
  // "Estimated Arrival date."), minus our own field, which we set explicitly.
  function formProperties(form, fs) {
    var out = {};
    controls(form).forEach(function (input) {
      if (!input.name || input.name.indexOf('properties[') !== 0) return;
      if (input.disabled) return;
      if (fs && fs.contains(input)) return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      var key = input.name.slice('properties['.length, -1);
      if (!key) return;
      out[key] = input.value;
    });
    return out;
  }

  function showError(fs, form, message) {
    var err = fs && fs.querySelector('[data-mtl-stitch-error]');
    if (err) {
      err.textContent = message;
      err.hidden = false;
    }
    var wrap = form.querySelector('.product-form__error-message-wrapper');
    var msg = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && msg) {
      msg.textContent = message;
      wrap.removeAttribute('hidden');
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('action') === null) return;
    if (form.action.indexOf('/cart/add') === -1) return;

    var host = form.closest('product-form');
    if (!host) return;

    var fs = fieldsetFor(form);
    var picked = chosen(fs);
    if (!picked.length) return; // nothing ticked — let the theme handle it untouched

    event.preventDefault();
    event.stopImmediatePropagation();

    var submitButton = host.querySelector('[type="submit"]');
    var spinner = host.querySelector('.loading__spinner');
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var variantId = fieldValue(form, 'id');
    var qty = Math.max(parseInt(fieldValue(form, 'quantity'), 10) || 1, 1);

    // The app keys the pair on a timestamp; keep the same shape so the cart
    // drawer's service lines and mtl-apo-qty-sync.js both still recognise it.
    var order = Date.now();
    var parentProps = formProperties(form, fs);
    parentProps[PARENT_PROP] = picked.map(function (p) { return p.label; }).join(', ');
    parentProps._apo_order = order;

    // Shopify puts each item of one /cart/add.js call ABOVE the previous one, so the
    // add-ons go first (reversed) and the saree last: the cart then reads saree,
    // then its services in the order they were ticked — the same order the app gave.
    var items = picked.slice().reverse().map(function (p) {
      return {
        id: p.id,
        quantity: qty,
        properties: {
          _apo_option: PARENT_PROP + ': ' + p.label,
          _apo_order: 'Added by: ' + order + ' * 1'
        }
      };
    });
    items.push({ id: variantId, quantity: qty, properties: parentProps });

    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    var url = String(window.routes.cart_add_url).replace(/\.js$/, '') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // Shopify rejected the whole batch; nothing was added.
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form', productVariantId: variantId,
            errors: response.errors || response.description, message: response.message
          });
          showError(fs, form, response.description || response.message || 'Could not add that to your cart.');
          return;
        }
        if (!cart) { window.location = window.routes.cart_url; return; }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form', productVariantId: variantId, cartData: response, productForm: host
        });
        cart.renderContents(response);
      })
      .catch(function () {
        showError(fs, form, 'Could not reach the cart. Please try again.');
      })
      .finally(function () {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }, true); // capture, so this runs before ProductForm's own listener

  document.querySelectorAll('[data-mtl-stitch]').forEach(sync);

  /* ------------------------------------------------------------------
     Already in the cart? Then changing the services should edit THAT line,
     not add a second saree. We only offer it as an explicit button — silently
     mutating a cart while someone ticks boxes is worse than an extra click.
     ------------------------------------------------------------------ */

  var ADDED_BY = /^Added by:\s*(\d+)\s*\*\s*(\d+)/;
  var bound = null; // { key, order, qty, properties, addons: [{key,label}] }

  function jfetch(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok || body.status) throw new Error(body.description || body.message || 'Cart error');
        return body;
      });
    });
  }

  function productForm() { return document.querySelector('product-form form'); }

  function currentVariantId() {
    var form = productForm();
    return form ? fieldValue(form, 'id') : null;
  }

  // The parent line for this exact variant, plus the add-ons hanging off it.
  function findInCart(cart) {
    var vid = currentVariantId();
    if (!vid || !cart || !cart.items) return null;
    var parents = cart.items.filter(function (i) {
      var raw = i.properties && i.properties._apo_order;
      var isAddon = typeof raw === 'string' && ADDED_BY.test(raw);
      return String(i.variant_id) === String(vid) && !isAddon;
    });
    if (parents.length !== 1) return null; // none, or ambiguous — leave it alone
    var p = parents[0];
    var order = p.properties && p.properties._apo_order;
    var addons = [];
    if (order != null) {
      cart.items.forEach(function (i) {
        var raw = i.properties && i.properties._apo_order;
        if (typeof raw !== 'string') return;
        var m = raw.match(ADDED_BY);
        if (m && m[1] === String(order)) {
          addons.push({ key: i.key, id: String(i.variant_id), label: (i.variant_title || '').trim() });
        }
      });
    }
    return { key: p.key, order: order, qty: p.quantity, properties: p.properties || {}, addons: addons };
  }

  function describe(list) {
    return list.length ? list.join(', ') : 'no stitching';
  }

  function paintInCart(fs) {
    var box = fs.querySelector('[data-mtl-stitch-incart]');
    var msg = fs.querySelector('[data-mtl-stitch-incart-msg]');
    if (!box) return;
    if (!bound) { box.hidden = true; return; }
    var onLine = String(bound.properties['Do you want to stitch'] || '')
      .split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var picked = chosen(fs).map(function (p) { return p.label; });
    var same = picked.length === onLine.length && picked.every(function (x) { return onLine.indexOf(x) > -1; });
    box.hidden = false;
    msg.textContent = same
      ? 'This saree is already in your cart with ' + describe(onLine) + '.'
      : 'Already in your cart with ' + describe(onLine) + '. Update it instead of adding another.';
    var btn = fs.querySelector('[data-mtl-stitch-update]');
    if (btn) {
      btn.disabled = same;
      btn.textContent = same ? 'Cart already matches' : 'Update the one in my cart';
    }
  }

  function refreshBinding() {
    var fs = document.querySelector('[data-mtl-stitch]');
    if (!fs) return;
    fetch(String(window.routes.cart_url).replace(/\.js$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bound = findInCart(cart);
        // Reflect what is on the line so the boxes match reality.
        if (bound) {
          var onLine = String(bound.properties['Do you want to stitch'] || '')
            .split(',').map(function (x) { return x.trim(); }).filter(Boolean);
          fs.querySelectorAll('.mtl-stitch__cb').forEach(function (cb) {
            cb.checked = onLine.indexOf(cb.value) > -1;
          });
          sync(fs);
        }
        paintInCart(fs);
      })
      .catch(function () { /* cart unreachable; the normal add path still works */ });
  }

  function applyUpdate(fs) {
    if (!bound) return;
    var btn = fs.querySelector('[data-mtl-stitch-update]');
    var picked = chosen(fs);
    var wantIds = picked.map(function (p) { return p.id; });
    var haveIds = bound.addons.map(function (a) { return a.id; });
    if (btn) { btn.disabled = true; btn.textContent = 'Updating…'; }

    // 1) parent properties. A saree added WITHOUT stitching has no _apo_order at
    //    all, so mint one here — otherwise the add-ons get "Added by: undefined"
    //    and can never be found again to remove.
    var order = bound.order;
    if (order === null || order === undefined || String(order) === '') order = Date.now();
    var props = {};
    Object.keys(bound.properties).forEach(function (k) { props[k] = bound.properties[k]; });
    if (picked.length) {
      props['Do you want to stitch'] = picked.map(function (p) { return p.label; }).join(', ');
      props._apo_order = order;
    } else {
      delete props['Do you want to stitch'];
      delete props._apo_order;
    }

    var chain = jfetch(String(window.routes.cart_change_url).replace(/\.js$/, '') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: bound.key, properties: props })
    });

    // 2) drop the add-ons that are no longer wanted
    bound.addons.forEach(function (a) {
      if (wantIds.indexOf(a.id) > -1) return;
      chain = chain.then(function () {
        return jfetch(String(window.routes.cart_change_url).replace(/\.js$/, '') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: a.key, quantity: 0 })
        });
      });
    });

    // 3) add the newly wanted ones, matched to the parent's quantity
    picked.forEach(function (p) {
      if (haveIds.indexOf(p.id) > -1) return;
      chain = chain.then(function () {
        return jfetch(String(window.routes.cart_add_url).replace(/\.js$/, '') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: p.id, quantity: bound.qty, properties: {
            _apo_option: PARENT_PROP + ': ' + p.label,
            _apo_order: 'Added by: ' + order + ' * 1'
          } }] })
        });
      });
    });

    chain
      .then(function () {
        // One final no-op update returns the fresh cart AND the rendered sections.
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { updates: {} };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return jfetch(String(window.routes.cart_update_url).replace(/\.js$/, '') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (state) {
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(state);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mtl-stitch-update', cartData: state });
        });
      })
      .then(function () { refreshBinding(); })
      .catch(function (err) {
        showError(fs, productForm() || document.body, err.message || 'Could not update your cart.');
        if (btn) { btn.disabled = false; btn.textContent = 'Update the one in my cart'; }
        refreshBinding();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mtl-stitch-update]');
    if (!btn) return;
    e.preventDefault();
    applyUpdate(btn.closest('[data-mtl-stitch]'));
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('mtl-stitch__cb')) {
      paintInCart(e.target.closest('[data-mtl-stitch]'));
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'mtl-stitch-update') return;
      setTimeout(refreshBinding, 300);
    });
  }
  refreshBinding();
})();
